const templates =  {
    "shop.okraina.ru": {
        title: "Отслеживание заказа",
        tags: [

        ]
    },
    "dostavka.okraina.ru": {
        title: "Отслеживание заказа",
        tags: [

        ]
    },
}

export default templates;